import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ReminderHelper } from '../reminder.helper';
import { ReminderService } from '../reminder.service';
import { UiService } from '../../../core/services/core.ui.service';

import * as moment from 'moment';

@Component({
    selector: 'reminder-add-modal',
    template: require('./reminder.add.modal.component.html')
})
export class ReminderAddModal implements OnInit {

    @Input() section: string;
    @Input('ref-id') refId: any;
    @Input() project: any;

    protected reminder: any;
    protected targetDate: any;
    protected schedulingTypeOptions: any;

    constructor(
        protected activeModal: NgbActiveModal,
        private reminderHelper: ReminderHelper, 
        private reminderService: ReminderService,
        private uiService: UiService) { }
    
    ngOnInit() {
        this.resetReminder();
        this.schedulingTypeOptions = this.reminderHelper.getSchedulingTypes();
    };

    resetReminder() {
        this.reminder = this.reminderHelper.getBlankReminder(this.section, this.refId);
        this.targetDate = {
            value: this.reminder.targetDate
        };
    }

    addReminder() {
        this.reminderService.post(this.reminder)
            .then(() => {
                this.uiService.message.showSuccess('Reminder "' + this.reminder.label + '" saved successfully', 'Reminder Saved');
                this.activeModal.close(true);
            })
            .catch(() => {
                // TODO validation display
                this.uiService.message.showError('Reminder "' + this.reminder.label + '" couldn\'t be saved', 'Reminder Save Error');
            });
    };

    selectSchedulingType = ($event) => {
        this.reminder.schedulingType = $event;
        this.recalculateTargetDate();
    };

    recalculateTargetDate() {
        this.reminder.targetDate = this.reminderHelper.getTargetDate(this.reminder.schedulingValue, this.reminder.schedulingType);
        this.targetDate = {
            value: this.reminder.targetDate
        };
    };

    datePickerCallback = (dateValue) => {
        var currSettingsDate: any = this.reminderHelper.getTargetDate(this.reminder.schedulingValue, this.reminder.schedulingType);
        if (currSettingsDate != dateValue) {
            var a = moment(dateValue);
            var b = moment();
            var diffDays = a.diff(b, 'days');

            if (diffDays > 0) {
                this.reminder.schedulingValue = diffDays;
                this.reminder.schedulingType = 1;
            } else if (diffDays > 0) {
                this.recalculateTargetDate();
                this.uiService.message.showError('You cannot set a day before current date!', 'Reminder Date Error');
            }
        }
    };

    notifyUsersCallback = (notifyUsers) => {
        this.reminder.notifyUsers = notifyUsers;
    };
}